import { cn } from '#app/utils/misc.tsx'

type HexProps = {
	/** Width in px. Height is derived from the glyph's intrinsic aspect ratio. */
	size?: number
	className?: string
	/** @deprecated Retained for API compatibility with the old line-art Hex; ignored by the cube glyph. */
	stroke?: number
	/** @deprecated Retained for API compatibility; ignored by the cube glyph. */
	subtle?: boolean
	/** @deprecated Retained for API compatibility; ignored by the cube glyph. */
	filled?: boolean
}

// Intrinsic dimensions of the Frame & Ledger cube glyph.
const GLYPH_VIEWBOX = '275 225 310 385'
const GLYPH_ASPECT = 385 / 310 // height / width

/**
 * The Frame & Ledger architectural cube mark.
 * Renders in `currentColor` so consumers control hue via `text-*` utilities;
 * defaults to architectural gold.
 */
export function Hex({ size = 28, className }: HexProps) {
	return (
		<span
			className={cn('inline-block text-gold', className)}
			style={{ width: size, height: Math.round(size * GLYPH_ASPECT) }}
			aria-hidden="true"
		>
			<svg
				viewBox={GLYPH_VIEWBOX}
				className="block h-full w-full"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill="currentColor"
					d="M479.043 309.918c-5.86-19.14-24.48-25.86-24.48-25.86-20.461-10.238-40.942-4-40.942-4-23.918 4.282-33.34 21.981-33.34 21.981-16.039 26.559 2.364 48.82 2.364 48.82.84 2.22 9.539 9.141 9.539 9.141l11.757 7.18 23.922 14.398 26.98-16.539c4.919-2.898 12.72-8.5 12.72-8.5l2.64-2.5-37.762-23.719 19.922-12.242 27.52 16.879s3.86-9.68-.84-25.039m59.898 62.621-19.5 12.04-26.937-16.7-64.82 39.781-135.403-81.68 61.723-37.44c-6.36 7.64-9.942 28.44-9.942 28.44l-14.539 9 21.579 12.72c-8.02-54.923 41.222-75.802 41.222-75.802 47.86-20.199 83 6.922 83 6.922 44.797 33.598 26.04 79.118 26.04 79.118Zm-37.718-84.14c7.742 12.539 10.058 28.581 10.058 28.581l14.383 9.137-13.922 8.281c-.097 4.622-1.937 11.36-1.937 11.36l10.039 6.262 42.98-25.903ZM528.243 357l18.26 11.238 1.481-1.097-.12 88.058 19.64-11.52V333.48Zm-46.22 146.418-.082-118.938-19.757 12.04v140.52L548.062 486v13.418l-96.539 57.82-.14-131.398 4.281-2.64.219-22.68-23.66 14.32v176.14l135.28-80.703V451.98Zm-194.539-169.7v176.34l49.938 30.301-.418-77.46 36.719 22.28v-22.84l-36.578-21.698v-17.903l61.117 36.282-.117-22.68-80.5-47.86v117.297l-10.942-6.636V367.18l97.66 58.097-.14 132.102-60.86-36.238-.242 19.297-.039 2.96 80.5 47.582.14-175.94Zm224.797 54.9-24.52 14.862V380.88l5.723-3.602Zm0 0"
				/>
			</svg>
		</span>
	)
}
